import sdkInstanceProvider from "@src/client/sdk/sdkInstanceProvider";
import {
  initialise,
  createAdobeSource,
  createEventBusSource,
  createAdobeDTMSink,
  createGtmSink,
  createOptimizelySink,
  createMixpanelSink
} from "@asosteam/asos-web-event-tracking-bridge";
import { eventBus } from "@src/helpers/eventing/events";
import { GTM_IFRAME, GTM_PARENT } from "./constants";
import { noticeError } from "@src/helpers/monitoring";
import { asosGlobalNamespace, sdkGlobalNamespace } from "@template/constants";
import { isProd } from "@src/helpers/isProd";
import clientConfig from "@template/clientConfig";

const initialiseEventTrackingBridge = () => {
  const featuresDelegate = sdkInstanceProvider("features");
  const { s: adobeDelegate } = window;

  const identitySdk = window[asosGlobalNamespace][sdkGlobalNamespace].identity;
  const { RELATIVE_API_BASE } = clientConfig.get();

  return initialise({
    sources: {
      adobe: createAdobeSource(adobeDelegate),
      eventBus: createEventBusSource(eventBus)
    },
    sinks: {
      adobeDTM: createAdobeDTMSink(isProd()),
      gtm: createGtmSink(GTM_PARENT, GTM_IFRAME, noticeError),
      optimizely: createOptimizelySink(featuresDelegate),
      mixpanel: createMixpanelSink("asos", {
        api_host: `${RELATIVE_API_BASE}/customer/signals/v1`
      })
    },
    config: {
      logError: noticeError,
      getIdTokenClaimsAsync: identitySdk.getIdTokenClaimsAsync,
      isAuthenticated: identitySdk.customer.isAuthenticated
    }
  });
};

export default initialiseEventTrackingBridge;
